import React from 'react';
import axios from 'axios';
import { useAlerts } from 'components/Alerts';
import Switch from 'components/subscriptions/Switch';

const EmailSwitch = ({ createPath, deletePath, projectSubscriptionTransportId = null}) => {
  const alerts = useAlerts();

  const [loading, setLoading] = React.useState(false);
  const [checked, setChecked] = React.useState(!!projectSubscriptionTransportId);

  const onCreate = React.useCallback(() => {
    setLoading(true);
    setChecked(true);
    axios.post(createPath, { project_subscription: { transport_type: 'SimpleMailTransport' } })
      .then((_response) => {
        // alerts.success('You have successfully subscribed to email notifications.');
        window.location.reload();
      })
      .catch(() => {
        setChecked(false);
        alerts.error('Could not subscribe to email notifications');
      })
      .finally(() => setLoading(false));
  }, [createPath]);

  const onDestroy = React.useCallback(() => {
    setLoading(true);
    setChecked(false);
    axios.delete(deletePath)
      .then(() => {
        // alerts.success('You have been unsubscribed from email notifications.');
        window.location.reload();
      })
      .catch(() => {
        setChecked(true);
        alerts.error('Could not unsubscribe from email notifications. Please try again or contact support@launchnotes.com for assistance');
      })
      .finally(() => setLoading(false));
  }, [deletePath]);

  return (
    <Switch
      id="email-switch"
      loading={loading}
      checked={checked}
      onChange={(value) => (value ? onCreate() : onDestroy())}
    />
  );
};

export default EmailSwitch;
